<template>
	<div class="circular-progress">
		<svg class="progress-ring" :width="size" :height="size">
			<circle
				class="progress-ring-background"
				:cx="center"
				:cy="center"
				:r="radius"
				:stroke-width="strokeWidth"
				fill="transparent"
			/>
			<circle
				class="progress-ring-circle"
				:cx="center"
				:cy="center"
				:r="radius"
				:stroke-width="strokeWidth"
				fill="transparent"
				:stroke-dasharray="circumference"
				:stroke-dashoffset="offset"
				transform="rotate(-90)"
				:transform-origin="`${center} ${center}`"
			/>
		</svg>
		<div class="progress-text">{{ formattedPercentage }}%</div>
	</div>
</template>

<script>
export default {
	name: 'CircularProgress',
	props: {
		percentage: {
			type: Number,
			default: 30,
			validator: value => value >= 0 && value <= 100
		},
		size: {
			type: Number,
			default: 44
		},
		strokeWidth: {
			type: Number,
			default: 8
		}
	},
	computed: {
		center() {
			return this.size / 2;
		},
		radius() {
			return (this.size - this.strokeWidth) / 2;
		},
		circumference() {
			return 2 * Math.PI * this.radius;
		},
		offset() {
			return this.circumference - (this.percentage / 100) * this.circumference;
		},
		formattedPercentage() {
			// 保留两位小数
			return this.percentage.toFixed(2);
		}
	}
};
</script>

<style scoped>
.circular-progress {
	position: relative;
	display: inline-block;
	top: 4px;
}


.progress-ring-background {
	stroke: #e0e0e0;
}

.progress-ring-circle {
	stroke: #fdc408;
	stroke-linecap: round;
	transition: stroke-dashoffset 0.3s ease;
}

.progress-text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 10px;
}
</style>

